<form #ngForm="ngForm" (ngSubmit)="selectPart(ngForm.form.value, submitter)">
  <div class="modal-body">
    <part-select name="part" ngModel (ngModelChange)="checkPartNumber($event)" [displayType]="displayType"
    [initialSearchTerm]="initialSearchTerm" [branch]="branch" [customer]="customer" required></part-select>
  </div>
  <a id="bct-parts-buyout-modal-btn" class="hyperlink px-4" (click)="openPartsBuyoutModal();">
    Parts Buyout
  </a>
  <div class="modal-footer">
    @if (displayType === 'back-counter-tool') {
      <button (click)="returnToRequest();" class="btn btn-secondary">Return to Request</button>
    }
    @if (displayType === 'navistar-punchout') {
      <button class="btn btn-primary" type="submit" (click)="setSubmitter('submit')" [disabled]="!ngForm.form.valid">Submit</button>
    }
    @if (hideNext) {
      <button class="btn btn-primary" type="submit" (click)="setSubmitter('next')" [disabled]="!ngForm.form.valid">Go to Next</button>
    }
  </div>
</form>
